<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 10:57:47
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 10:58:55
 * @FilePath: \vue-privilege-routing\src\pages\conduct-main\organize-manage\index.vue
-->
<template>
    <div>
       组织管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
